import { render, staticRenderFns } from "./AvailabilitySettings.vue?vue&type=template&id=64e64a64&"
import script from "./AvailabilitySettings.vue?vue&type=script&lang=js&"
export * from "./AvailabilitySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports